import { render, staticRenderFns } from "./CancelTeacherAccountModal.vue?vue&type=template&id=c685668a&scoped=true&"
import script from "./CancelTeacherAccountModal.vue?vue&type=script&lang=js&"
export * from "./CancelTeacherAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./CancelTeacherAccountModal.vue?vue&type=style&index=0&id=c685668a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c685668a",
  null
  
)

export default component.exports